import { call, takeLatest } from "redux-saga/effects";
import {
  bounceReportApi,
  branchWiseSalesReportApi,
  customerPurchaseBehaviorReportApi,
  customerPurchaseFreqReportApi,
  dailySalesReportApi,
  discountAnalysisReportApi,
  doctorWiseSalesReportApi,
  expiryLossReportApi,
  gstR1ReportApi,
  gstr2AReportApi,
  gstr3bReportApi,
  inventoryReportApi,
  inventorySalesReportApi,
  overallSalesReportApi,
  partyWiseProfitReportApi,
  partyWiseSalesReportApi,
  paymentModeWiseSalesReportApi,
  productWiseSalesReportApi,
  salesReturnReportApi,
  scheduledHDrugRegReportApi,
  slowAndFastMovingProductsReportApi,
  productPurchaseReturnReportWorkerReportApi,
  SavedReportsReportWorkertApi,
  SavedReportsReportDataWorkertApi,
  B2bSalesSummaryReportWorkerReportApi,
  StorePurchaseReportWorkerReportApi,
  ReOrderReportWorkerReportApi,
  GetAddedFavApi,
  SetAddedFavApi,
  productInfoApi,
  purchaseOrderReportApi,
  profitReportApi,
  VendorMasterReportApi,
  StockLedgerReportApi,
  vendorPaybleReportApi,
  dayWiseReportApi,
  customerPayableApi,
  AddTagsApi,
  GetTagsApi,
  addBounceReportApi
} from "../apis/report-api";
import {
  BOUNCE_REPORT,
  BRANCH_WISE_SALES_REPORT,
  DAILY_SALES_REPORT,
  DISCOUNT_ANALYSIS_REPORT,
  DOCTOR_WISE_SALES_REPORT,
  EXPIRY_LOSS_REPORT,
  CUSTOMER_PAYABLE,
  GSTR1_REPORT,
  GSTR2A_REPORT,
  GSTR3B_REPORT,
  INVENTORY_REPORT,
  INVENTORY_SALES_REPORT,
  OVERALL_SALES_REPORT,
  PARTY_WISE_PROFIT_REPORT,
  PARTY_WISE_SALES_REPORT,
  PAYMENT_MODE_WISE_SALES_REPORT,
  PRODUCT_WISE_SALES_REPORT,
  PURCHASE_BEHAVIOR_REPORT,
  PURCHASE_FREQ_REPORT,
  SALES_RETURN_REPORT,
  SCHEDULED_HDRUG_REG_REPORT,
  SLOW_FAST_MOVING_PRODUCTS,
  PRODUCT_PURCHASE_RETURN_REPORT,
  SAVED_REPORTS,
  SAVED_DATA_REPORTS,
  B2B_SALES_SUMMARY_REPORT,
  STORE_PURCHASE_REPORT,
  FAV_ITEMS,
  SET_FAV_ITEMS,
  PRODUCT_INFO_REPORT,
  PURCHASE_ORDER_REPORT,
  PROFIT_REPORT,
  VENDOR_MASTER,
  STOCK_LEDGER_BATCH,
  VENDOR_PAYABLE,
  DAY_WISE,
  REORDER_REPORT,
  ADD_TAGS,
  GET_TAGS,
  ADD_BOUNCE_REPORT
} from "../types";

/**Sales Reports */
export function* overallSalesReportWorker(action) {
  try {
    const res = yield call(overallSalesReportApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* dailySalesReportWorker(action) {
  try {
    const res = yield call(dailySalesReportApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* branchWiseSalesReportWorker(action) {
  try {
    const res = yield call(branchWiseSalesReportApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* productWiseSalesReportWorker(action) {
  try {
    const res = yield call(productWiseSalesReportApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* productPurchaseReturnReportWorker(action) {
  try {
    const res = yield call(productPurchaseReturnReportWorkerReportApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* GetFavWorker(action) {
  try {
    const res = yield call(GetAddedFavApi, action.data);
    if (res.status === 200) {

      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* SetFavWorker(action) {
  try {
    const res = yield call(SetAddedFavApi, action.data);
    if (res.status === 200) {

      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* B2bSalesSummaryWorker(action) {
  try {
    const res = yield call(B2bSalesSummaryReportWorkerReportApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* StorePurchaseReportWorker(action) {
  try {
    const res = yield call(StorePurchaseReportWorkerReportApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* ReOrderReportWorker(action) {
  try {
    const res = yield call(ReOrderReportWorkerReportApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* SavedReportsReportWorker(action) {
  try {
    const res = yield call(SavedReportsReportWorkertApi, action.data);
    if (res.status === 200) {

      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* AddTagsWorker(action) {
  try {
    const res = yield call(AddTagsApi, action.data);
    if (res.status === 200) {

      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* GetTagsWorker(action) {
  try {
    const res = yield call(GetTagsApi, action.data);
    if (res.status === 200) {

      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* SavedReportsReportDataWorker(action) {
  try {
    const res = yield call(SavedReportsReportDataWorkertApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* doctorWiseSalesReportWorker(action) {
  try {
    const res = yield call(doctorWiseSalesReportApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* partyWiseSalesReportWorker(action) {
  try {
    const res = yield call(partyWiseSalesReportApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* paymentModeWiseSalesReportWorker(action) {
  try {
    const res = yield call(paymentModeWiseSalesReportApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

/**Financial & Revenue */

export function* partyWiseProfitReportWorker(action) {
  try {
    const res = yield call(partyWiseProfitReportApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* discountAnalysisReportWorker(action) {
  try {
    const res = yield call(discountAnalysisReportApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

/**Sales Retrun */
export function* salesReturnReportWorker(action) {
  try {
    const res = yield call(salesReturnReportApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

/**Customer Reorts */
export function* customerPurchaseFreqReportWorker(action) {
  try {
    const res = yield call(customerPurchaseFreqReportApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* customerPurchaseBehaviorReportWorker(action) {
  try {
    const res = yield call(customerPurchaseBehaviorReportApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* bounceReportWorker(action) {
  try {
    const res = yield call(bounceReportApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* inventorySalesReportWorker(action) {
  try {
    const res = yield call(inventorySalesReportApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* inventoryReportWorker(action) {
  try {
    const res = yield call(inventoryReportApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* scheduledHDrugRegReportWorker(action) {
  try {
    const res = yield call(scheduledHDrugRegReportApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* expiryLossReportWorker(action) {
  try {
    const res = yield call(expiryLossReportApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* customerPayableReportWorker(action) {
  try {
    const res = yield call(customerPayableApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* productInfoWorker(action) {
  try {
    const res = yield call(productInfoApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* profitReportWorker(action) {
  try {
    const res = yield call(profitReportApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* VendorMasterWorker(action) {
  try {
    const res = yield call(VendorMasterReportApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* StockLedgerBatchWorker(action) {
  try {
    const res = yield call(StockLedgerReportApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* vendorPayableBatchWorker(action) {
  try {
    const res = yield call(vendorPaybleReportApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* dayWiseBatchWorker(action) {
  try {
    const res = yield call(dayWiseReportApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* slowAndFastMovingProductsReportWorker(action) {
  try {
    const res = yield call(slowAndFastMovingProductsReportApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* gstR1ReportWorker(action) {
  try {
    const res = yield call(gstR1ReportApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* gstr2AReportWorker(action) {
  try {
    const res = yield call(gstr2AReportApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* gstr3bReportWorker(action) {
  try {
    const res = yield call(gstr3bReportApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* purchaseOrderReportWorker(action) {
  try {
    const res = yield call(purchaseOrderReportApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

/**Sales Report */
export function* overallSalesReportWatcher() {
  yield takeLatest(OVERALL_SALES_REPORT, overallSalesReportWorker);
}

export function* dailySalesReportWatcher() {
  yield takeLatest(DAILY_SALES_REPORT, dailySalesReportWorker);
}

export function* branchWiseSalesReportWatcher() {
  yield takeLatest(BRANCH_WISE_SALES_REPORT, branchWiseSalesReportWorker);
}

export function* productWiseSalesReportWatcher() {
  yield takeLatest(PRODUCT_WISE_SALES_REPORT, productWiseSalesReportWorker);
}

export function* productPurchaseReturnReportWatcher() {
  yield takeLatest(PRODUCT_PURCHASE_RETURN_REPORT, productPurchaseReturnReportWorker);
}

export function* B2bSalesSummaryReportWatcher() {
  yield takeLatest(B2B_SALES_SUMMARY_REPORT, B2bSalesSummaryWorker);
}

export function* StorePurchaseReportWatcher() {
  yield takeLatest(STORE_PURCHASE_REPORT, StorePurchaseReportWorker);
}

export function* ReOrderReportWatcher() {
  yield takeLatest(REORDER_REPORT, ReOrderReportWorker);
}


export function* AddTagsWorkertWatcher() {
  yield takeLatest(ADD_TAGS, AddTagsWorker);
}

export function* GetTagsWorkertWatcher() {
  yield takeLatest(GET_TAGS, GetTagsWorker);
}

export function* SavedReportsReportWorkertWatcher() {
  yield takeLatest(SAVED_REPORTS, SavedReportsReportWorker);
}

export function* SavedReportsReportDataWorkertWatcher() {
  yield takeLatest(SAVED_DATA_REPORTS, SavedReportsReportDataWorker);
}

export function* doctorWiseSalesReportWatcher() {
  yield takeLatest(DOCTOR_WISE_SALES_REPORT, doctorWiseSalesReportWorker);
}

export function* partyWiseSalesReportWatcher() {
  yield takeLatest(PARTY_WISE_SALES_REPORT, partyWiseSalesReportWorker);
}

export function* paymentModeWiseSalesReportWatcher() {
  yield takeLatest(
    PAYMENT_MODE_WISE_SALES_REPORT,
    paymentModeWiseSalesReportWorker
  );
}

/**Financial & Revenue */
export function* partyWiseProfitReportWatcher() {
  yield takeLatest(PARTY_WISE_PROFIT_REPORT, partyWiseProfitReportWorker);
}

export function* discountAnalysisReportWatcher() {
  yield takeLatest(DISCOUNT_ANALYSIS_REPORT, discountAnalysisReportWorker);
}

export function* salesReturnReportWatcher() {
  yield takeLatest(SALES_RETURN_REPORT, salesReturnReportWorker);
}

export function* customerPurchaseFreqReportWatcher() {
  yield takeLatest(PURCHASE_FREQ_REPORT, customerPurchaseFreqReportWorker);
}

export function* customerPurchaseBehaviorReportWatcher() {
  yield takeLatest(
    PURCHASE_BEHAVIOR_REPORT,
    customerPurchaseBehaviorReportWorker
  );
}

export function* bounceReportWatcher() {
  yield takeLatest(BOUNCE_REPORT, bounceReportWorker);
}

export function* inventorySalesReportWatcher() {
  yield takeLatest(INVENTORY_SALES_REPORT, inventorySalesReportWorker);
}

export function* inventoryReportWatcher() {
  yield takeLatest(INVENTORY_REPORT, inventoryReportWorker);
}

export function* scheduledHDrugRegReportWatcher() {
  yield takeLatest(SCHEDULED_HDRUG_REG_REPORT, scheduledHDrugRegReportWorker);
}

export function* expiryLossReportWatcher() {
  yield takeLatest(EXPIRY_LOSS_REPORT, expiryLossReportWorker);
}

export function* customerPayableReportWatcher() {
  yield takeLatest(CUSTOMER_PAYABLE, customerPayableReportWorker);
}


export function* ProductInfoWatcher() {
  yield takeLatest(PRODUCT_INFO_REPORT, productInfoWorker);
}

export function* ProfitReportWatcher() {
  yield takeLatest(PROFIT_REPORT, profitReportWorker);
}

export function* VendorMasterReportWatcher() {
  yield takeLatest(VENDOR_MASTER, VendorMasterWorker);
}

export function* StockLedgerBatchReportWatcher() {
  yield takeLatest(STOCK_LEDGER_BATCH, StockLedgerBatchWorker);
}

export function* vendorPayableReportWatcher() {
  yield takeLatest(VENDOR_PAYABLE, vendorPayableBatchWorker);
}

export function* dayWiseReportWatcher() {
  yield takeLatest(DAY_WISE, dayWiseBatchWorker);
}

export function* slowAndFastMovingProductsReportWatcher() {
  yield takeLatest(
    SLOW_FAST_MOVING_PRODUCTS,
    slowAndFastMovingProductsReportWorker
  );
}
export function* gstR1ReportWatcher() {
  yield takeLatest(GSTR1_REPORT, gstR1ReportWorker);
}
export function* gstr2AReportWatcher() {
  yield takeLatest(GSTR2A_REPORT, gstr2AReportWorker);
}
export function* gstr3bReportWatcher() {
  yield takeLatest(GSTR3B_REPORT, gstr3bReportWorker);
}

export function* GetFavWorkertWatcher() {
  yield takeLatest(FAV_ITEMS, GetFavWorker);
}

export function* SetFavWorkertWatcher() {
  yield takeLatest(SET_FAV_ITEMS, SetFavWorker);
}

export function* purchaseOrderReportWatcher() {
  yield takeLatest(PURCHASE_ORDER_REPORT, purchaseOrderReportWorker);
}

export function* addBounceReportWorker(action) {
  try {
    const res = yield call(addBounceReportApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* addBounceReportWatcher() {
  yield takeLatest(ADD_BOUNCE_REPORT, addBounceReportWorker);
}